import axios from 'axios';

export const dashboardSuperAdminApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/dashboard-superadmin`,
    headers: {
        'Content-Type': 'application/json'
    }
})